export default __webpack_public_path__ + "static/media/article_5.4c741913.jpg";